<template>
  <div class="loginPage">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <NavBar :bgColor="'#1A3232'"/>
    
    <Login/>


  </div>
</template>

<script>

import NavBar from '@/components/NavBar/index.vue'
import Login from '@/components/Login/index.vue'
export default {
  name: 'loginPage',
  data(){
    return {
      
      
    }
  },
  components: {
    NavBar,
    Login,
  },
  methods:{
  

  }
}
</script>

<style lang="scss" scoped>

  .loginPage{
    width: 100%;
    height: 100%;
    .sticky{
      position: -webkit-sticky; /* Safari 兼容 */
      position: sticky;
      top: 0;
    }
   
    

      
  }
  
</style>
